import "./App.css";
import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import Validations from "./scenes/validations";
import PayoutsArchive from "./scenes/payoutsArchive";
import Payouts from "./scenes/payouts";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import DataGridDemo from "./scenes/contacts/DataGridDemo";
import FilterReports from "./scenes/faq/details";

import FAQ from "./scenes/faq";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import SignInSide from "./scenes/login/SignInSide";
import * as CONSTANT from "./constants/Constant";
import FinanceHomePage from "./scenes/dashboard/finance/FinanceHomePage";

import { OnHoldSummary } from "./scenes/onhold";
import ExclusionScreen from "./scenes/exclusion";
import { WitholdingTaxScreen } from "./scenes/witholdingTax";
import { FreezeAccountScreen } from "./scenes/freezeAccount";
import { CreditDebitScreen } from "./scenes/creditDebit";
import PayoutDatesScreen from "./scenes/payoutDates/index";
import { EarmarkScreen } from "./scenes/earmark";
import PayoutsTransactionDetails from "./scenes/payoutsArchive/PayoutsTransactionDetails";
import PayoutsDealerBreakdown from "./scenes/payoutsArchive/PayoutsDealerBreakdown";
import { OnHoldDetails } from "./scenes/onhold/OnHoldDetails";
import { OnHoldAllTransactionsDetails } from "./scenes/onhold/OnHoldAllTransactionsDetails";
import SuccessPage from "./scenes/success/SuccessPage";
import { AddDealerScreen } from "./scenes/earmark/AddDealer";
import { FreezeUnfreezeDealer } from "./scenes/freezeAccount/FreezeUnfreezeDealer";
import AddAdjustments from "./scenes/creditDebit/AddAdjustments";
import { AddDealerScreenCreditDebit } from "./scenes/creditDebit/AddDealerScreenCreditDebit";
import CancelAdjustmentSuccess from "./scenes/creditDebit/CancelAdjustmentSuccess";
import AdjustmentSuccess from "./scenes/creditDebit/AjustmentSuccess";
import { OnHoldDealerBreakdown } from "./scenes/onhold/OnHoldDealerBreakdown";
import OnHoldActionItemsSuccess from "./scenes/onhold/OnHoldActionItemsSuccess";
import PayoutsActionItemsSuccess from "./scenes/payoutsArchive/PayoutsActionItemsSuccess";
import { AddExclusionDealer } from "./scenes/exclusion/AddExclusionDealer";

import AddAdjustmentToExclusion from "./scenes/exclusion/AddAdjustmentToExclusion";
import RemovedExclusionTransactionTypeScreen from "./scenes/exclusion/RemovedExclusionTransactionTypeScreen";
import { RemovedExclusionTransacionDetails } from "./scenes/exclusion/RemovedExclusionTransacionDetails";
import { RemovedExclusionTrasactionData } from "./scenes/exclusion/RemovedExclusionTrasactionData";

import { CashOutLimitsScreen } from "./scenes/cashOutLimits";
import ExclusionSuccessPage from "./scenes/exclusion/SuccessPage";
import { SearchAndSelectCompanyDetails } from "./scenes/faq/SearchAndSelectCompanyDetails";
import ChangePassword1 from "./scenes/changeUserCredentials/ChangePassword";
import ChangeUsername from "./scenes/changeUserCredentials/ChangeUsername";
import ForgotPassword from "./scenes/changeUserCredentials/ForgotPassword";

import ChangePassword from "./scenes/settings/changePassword";
import ResetPasswordOnUrlLinkClick from "./scenes/changeUserCredentials/ResetPasswordOnUrlLinkClick";
import ForgotUsername from "./scenes/changeUserCredentials/ForgotUsername";
import PayoutDealerSummary from "./scenes/onhold/PayoutsDealerSummary";
import OnHoldPayoutCycles from "./scenes/onhold/OnHoldPayoutCycles";

//import RouteB from './scenes/payoutsArchive/payoutsArchive';

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(false);
  // Prevent clicks on the progress indicator itself from affecting the loading state
  const handleProgressClick = (event) => {
    event.stopPropagation();
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <div className="app" onClick={handleProgressClick}>
          <Sidebar isSidebar={isSidebar} />

          {/* {!isCollapsed && ( */}
          {/* // <main className="content"> */}

          <main id="mainContent" className="content">
            <Topbar setIsSidebar={setIsSidebar} />
            <Routes>
              <Route path="/" element={<SignInSide />} />
              <Route path={CONSTANT.LOGIN} element={<SignInSide />} />
              <Route
                path={CONSTANT.FINANCE_DASHBOARD}
                element={<FinanceHomePage />}
              />
              {/* <Route path={CONSTANT.DELAER_DASHBOARD_ROUTE} element={<Dashboard />} /> */}
              <Route
                path={CONSTANT.VALIDATION_ROUTE}
                element={<Validations />}
              />
              <Route
                path={CONSTANT.PAYOUT_ARCHIVE_ROUTE}
                element={<PayoutsArchive />}
              />
              <Route
                path={CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE}
                element={<PayoutDealerSummary />}
              />
              <Route
                path={CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE}
                element={<OnHoldPayoutCycles />}
              />
              <Route path={CONSTANT.PAYOUT_ROUTE} element={<Payouts />} />
              <Route
                path={CONSTANT.ON_HOLD_ROUTE}
                element={<OnHoldSummary />}
              />
              <Route path={CONSTANT.CONTACT_ROUTE} element={<Contacts />} />
              <Route path={CONSTANT.INVOICES_ROUTE} element={<Invoices />} />
              <Route
                path={CONSTANT.EXCLUSION_ROUTE}
                element={<ExclusionScreen />}
              />
              <Route
                path={CONSTANT.PAYOUT_DATES_ROUTE}
                element={<PayoutDatesScreen />}
              />
              <Route
                path={CONSTANT.WITHOLDING_TAX_ROUTE}
                element={<WitholdingTaxScreen />}
              />
              <Route
                path={CONSTANT.FREEZE_ACCOUNT_ROUTE}
                element={<FreezeAccountScreen />}
              />
              <Route
                path={CONSTANT.CREDIT_DEBIT_ROUTE}
                element={<CreditDebitScreen />}
              />
              <Route path={CONSTANT.REPORTS_ROUTE} element={<FAQ />} />
              <Route
                path={CONSTANT.EARMARK_ROUTE}
                element={<EarmarkScreen />}
              />
              <Route
                path={CONSTANT.REPORTS_FILTER_ROUTE}
                element={<FilterReports />}
              />
              <Route
                path={CONSTANT.PAYOUT_ALL_TRANSACTION_DETAILS}
                element={<PayoutsTransactionDetails />}
              />
              <Route
                path={CONSTANT.PAYOUT_DEALER_BREAKDOWN}
                element={<PayoutsDealerBreakdown />}
              />
              <Route
                path={CONSTANT.ON_HOLD_DETAILS_ROUTE}
                element={<OnHoldDetails />}
              />
              <Route
                path={CONSTANT.ON_HOLD_DEALERS_ROUTE}
                element={<OnHoldDealerBreakdown />}
              />
              <Route
                path={CONSTANT.ON_HOLD_ALL_TRANSACTIONS_DETAILS}
                element={<OnHoldAllTransactionsDetails />}
              />
              <Route path={CONSTANT.SUCCESS_ROUTE} element={<SuccessPage />} />
              <Route
                path={CONSTANT.ADD_DEALER_ROUTE}
                element={<AddDealerScreen />}
              />
              <Route
                path={CONSTANT.UNFREEZE_FREEZE_DEALER_ROUTE}
                element={<FreezeUnfreezeDealer />}
              />
              <Route
                path={CONSTANT.ADD_ADJUSTMENTS_ROUTE}
                element={<AddAdjustments />}
              />
              <Route
                path={CONSTANT.SEARCH_DEALER_CREDIT_DEBIT_ROUTE}
                element={<AddDealerScreenCreditDebit />}
              />
              <Route
                path={CONSTANT.CANCEL_ADJUSTMENT_SUCCESS_ROUTE}
                element={<CancelAdjustmentSuccess />}
              />
              <Route
                path={CONSTANT.ON_HOLD_ACTION_ITEM_SUCCESS_ROUTE}
                element={<OnHoldActionItemsSuccess />}
              />
              <Route
                path={CONSTANT.ADJUSTMENT_SUCCESS_ROUTE}
                element={<AdjustmentSuccess />}
              />
              <Route
                path={CONSTANT.ADD_EXCLUSION_DEALER_ROUTE}
                element={<AddExclusionDealer />}
              />
              <Route
                path={CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE}
                element={<PayoutsActionItemsSuccess />}
              />
              <Route
                path={CONSTANT.ADD_ADJUSTMENT_TO_EXCLUSION_ROUTE}
                element={<AddAdjustmentToExclusion />}
              />
              <Route
                path={CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE}
                element={<RemovedExclusionTransactionTypeScreen />}
              />
              <Route
                path={CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE}
                element={<RemovedExclusionTransacionDetails />}
              />
              <Route
                path={CONSTANT.REMOVED_EXCLUSION_TRANSACTIONS_ROUTE}
                element={<RemovedExclusionTrasactionData />}
              />
              <Route
                path={CONSTANT.CASHOUT_LIMITS_ROUTE}
                element={<CashOutLimitsScreen />}
              />
              <Route
                path={CONSTANT.EXCLUSION_SUCCESS_ROUTE}
                element={<ExclusionSuccessPage />}
              />
            
              <Route
                path={CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE}
                element={<SearchAndSelectCompanyDetails />}
              />
              {/* <Route path={CONSTANT.FORMS_ROUTE} element={<Form />} /> */}
              <Route path="/team" element={<DataGridDemo />} />
              <Route
                path={CONSTANT.CHANGE_PASSWORD_ROUTE}
                element={<ChangePassword1 />}
              />
              <Route
                path={CONSTANT.CHANGE_USERNAME_ROUTE}
                element={<ChangeUsername />}
              />
              <Route
                path={CONSTANT.FORGOT_PASSWORD_ROUTE}
                element={<ForgotPassword />}
              />
              <Route
                path={CONSTANT.FORGOT_USERNAME_ROUTE}
                element={<ForgotUsername />}
              />
              <Route
                path={CONSTANT.CHANGE_PASSWORD}
                element={<ChangePassword />}
              />
              <Route
                path={CONSTANT.RESET_PASSWORD_ON_URL_LINK_CLICK}
                element={<ResetPasswordOnUrlLinkClick />}
              />

              {/* Role and Access Management related routes start */}
              {/* <Route
                path={CONSTANT.CLUSTER_LISTING_ROUTE}
                element={<ClusterListingPage />}
              />
              <Route
                path={CONSTANT.CREATE_CLUSTER_ROUTE}
                element={<CreateClusterPage />}
              />
              <Route
                path={CONSTANT.CLUSTER_DETAILS_ROUTE}
                element={<ClusterInfoPage />}
              />
              <Route
                path={CONSTANT.ROLES_ROUTE}
                element={<RoleAccessPage />}
              />
              <Route
                path={CONSTANT.CREATE_ROLES_ROUTE}
                element={<AddNewRole />}
              />
              <Route
                path={CONSTANT.USERS_ROUTE}
                element={<UsersPage />}
              />
              <Route
                path={CONSTANT.MODULES_ROUTE}
                element={<ModulesPage />}
              />
              <Route
                path={CONSTANT.MODULES_UPDATE_SUCCESS_ROUTE}
                element={<ModuleUpdateSuccess />}
              />
              <Route
                path={CONSTANT.REQUEST_ROUTE}
                element={<RequestPage />}
              />
              <Route
                path={CONSTANT.REQUEST_DETAILS_ROUTE}
                element={<RequestDetailPage />}
              />
              <Route
                path={CONSTANT.HIERARCHY_ROUTE}
                element={<HierarchyPage />}
              />
              <Route
                path={CONSTANT.LOG_ROUTE}
                element={<LogPage />}
              />
              <Route
                path={CONSTANT.LOG_DETAILS_ROUTE}
                element={<LogDetailPage />}
              /> */}
              {/* Role and Access Management related routes end */}


              {/* 
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/line" element={<Line />} /> 
              <Route path="/calendar" element={<Calendar />}
              <Route path="/geography" element={<Geography />} /> */}

               <Route path="/faq" element={<FAQ />} />
              {/* <Route path="*" element={<PageNotFound />} /> */}
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
